import { useState, useEffect } from "react";

import { Button } from "react-bootstrap";
import Modal from "../modal";

import "./availableForCheckoutShift.css";

import {
  IAvailableForCheckoutShift,
  IEmployee,
  ILanguageData,
  IPropsAvailableForCheckoutShiftComponent,
} from "./interface";

export default function AvailableForCheckoutShiftComponent(
  props: IPropsAvailableForCheckoutShiftComponent
) {
  const [shift, setShift] = useState<IAvailableForCheckoutShift>();
  const [showModal, setShowModal] = useState(false);
  const [showPostFailedModal, setShowPostFailedModal] = useState(false);
  const [shiftIdStr, setShiftIdStr] = useState<string>();
  const [year, setYear] = useState<string>();
  const [month, setMonth] = useState<string>();
  const [day, setDay] = useState<string>();
  const [languageData, setLanguageData] = useState<ILanguageData>({
    shiftId: "",
    shiftDate: "",
    shiftNo: "",
    employeeName: "",
    cash: "",
    note: "",
    totalCash: "",
    show: "",
    hide: "",
    save: "",
    loading: "",
    modalCheckButton: "",
    modalCheckQuestion: "",
    modalPostFailedButton: "",
    modalPostFailedQuestion: "",
  });

  useEffect(() => {
    setShift({ ...props.shift });
  }, [
    props.shift,
    props.shift.inputHidden,
    props.shift.isPostFailed,
    props.shift.isSaving,
  ]);

  useEffect(() => {
    setLanguageData({ ...props.languageData.data.availableForCheckoutShift });
  }, [props.languageData.appLanguage]);

  useEffect(() => {
    setShiftIdStr(shift?.shiftId.toString());
  }, [shift]);

  useEffect(() => {
    if (shiftIdStr) {
      setYear(shiftIdStr.slice(0, 4));
      setMonth(shiftIdStr.slice(4, 6));
      setDay(shiftIdStr.slice(6, 8));
    }
  }, [shiftIdStr]);

  const toggleShowModal = () => {
    setShowModal(!showModal);
  };

  const toggleShowPostFailedModal = () => {
    if (shift) {
      setShift({ ...shift, isPostFailed: false });
    }
  };

  const handleSaveInternally = () => {
    toggleShowModal();
    if (shift) {
      props.saveButtonClicked(shift);
    }
  };

  const handleSaveInternallyFailed = () => {
    if (shift) {
      props.saveButtonClicked(shift);
    }
  };

  let cashSum = 0;

  if (shift) {
    shift?.employees.forEach((employee: any) => {
      cashSum += employee.amount;
    });
  }

  // const shiftIdStr = shift.shiftId.toString();
  // const year = shiftIdStr.slice(0, 4);
  // const mouth = shiftIdStr.slice(4, 6);
  // const day = shiftIdStr.slice(6, 8);
  let component = null;
  if (shift) {
    component = (
      <div className={"component-custom-border"}>
        <table className={"table-custom-border"} key={shift.shiftId}>
          <thead className={"first-thead"}>
            <tr>
              {/* {console.log("aaa", languageData)}
              {console.log("bbb", languageData?.shiftId)} */}
              <th className={"custom-th-td"}>{languageData.shiftId}</th>
              <th className={"custom-th-td"}> {languageData.shiftDate} </th>
              <th className={"custom-th-td"}> {languageData.shiftNo}</th>
            </tr>
            <tr>
              <td className={"custom-th-td"}>{shift.shiftId}</td>
              <td className={"custom-th-td"}>
                {day}/{month}/{year}
              </td>
              <td className={"custom-th-td"}>{shiftIdStr?.slice(-2)}</td>
            </tr>
          </thead>
        </table>
        <div>
          <table
            className={
              shift.inputHidden
                ? "hiddenU table-custom-border"
                : "hiddenU.open table-custom-border"
            }
          >
            <thead className={shift.inputHidden ? "hiddenU" : ""}>
              <tr>
                <th className={"custom-th-td custom-th-td-top"}>
                  {" "}
                  {languageData.employeeName}
                </th>
                <th className={"custom-th-td custom-th-td-top"}>
                  {" "}
                  {languageData.cash}
                </th>
                <th className={"custom-th-td custom-th-td-top"}>
                  {languageData.note}
                </th>
              </tr>
            </thead>
            <tbody>
              {shift.employees.map((el: IEmployee, index: number) => {
                return (
                  <tr key={el.shiftCashEntityId}>
                    <td className={"custom-th-td"}>{el.employeeName}</td>
                    <td className={"custom-th-td"}>
                      <input
                        className={"custom-input"}
                        key={el.shiftCashEntityId + index + "amount_input"}
                        type="number"
                        value={
                          el.amount === 0 ||
                          el.amount === null ||
                          el.amount === undefined
                            ? ""
                            : el.amount
                        }
                        onChange={(element) =>
                          props.onCashInputChange(
                            shift.shiftId,
                            el.employeeName,
                            element
                          )
                        }
                      />
                    </td>
                    <td className={"custom-th-td"}>
                      <input
                        className={"custom-input"}
                        key={el.shiftCashEntityId + index + "note_input"}
                        value={el.note === null ? "" : el.note}
                        onChange={(element: any) =>
                          props.onNoteInputChange(
                            shift.shiftId,
                            el.employeeName,
                            element
                          )
                        }
                      />
                    </td>
                  </tr>
                );
              })}
            </tbody>
            <thead>
              <tr>
                <th className={"custom-th-td custom-th-td-top"}>
                  {" "}
                  {languageData.totalCash}{" "}
                </th>
                <th className={"custom-th-td custom-th-td-top"}>
                  {" "}
                  {typeof cashSum === "undefined" || Number.isNaN(cashSum)
                    ? 0
                    : cashSum}
                  &#8378;
                </th>
                <th className={"custom-th-td-top"}></th>
              </tr>
            </thead>
          </table>
        </div>
        <div>
          <Button
            className={"custom-btn"}
            onClick={() => props.toggleButtonClicked(shift.shiftId)}
          >
            {shift.inputHidden ? languageData.show : languageData.hide}
          </Button>
          {shift.inputHidden ? null : (
            <Button
              className={"custom-btn"}
              disabled={shift.isSaving}
              onClick={toggleShowModal}
            >
              {shift.isSaving && (
                <span
                  className="spinner-border spinner-border-sm"
                  role="status"
                  aria-hidden="true"
                ></span>
              )}
              {shift.isSaving ? languageData.loading : languageData.save}
            </Button>
          )}
        </div>

        <Modal
          show={showModal}
          handleClose={toggleShowModal}
          onTrue={handleSaveInternally}
          buttonText={languageData.modalCheckButton}
          totalCash={cashSum}
          question={languageData.modalCheckQuestion}
        ></Modal>
        <Modal
          show={shift.isPostFailed}
          handleClose={toggleShowPostFailedModal}
          onTrue={handleSaveInternallyFailed}
          buttonText={languageData.modalPostFailedButton}
          totalCash={cashSum}
          question={languageData.modalPostFailedQuestion}
        />
      </div>
    );
  }

  return <div>{component}</div>;
}
